import React from "react"
import { useSelector } from "react-redux"
import { FaCoins, FaMoneyBillWave } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { isDirectionLtr } from "utils"
import { RadioButton } from "components"
import classes from "./KcPaymentMethods.module.scss"

const KcPaymentMethods = props => {
  const { paymentType, setPaymentType } = props

  const [t] = useTranslation()

  const paymentOptions =
    useSelector(state => state.systemSettings.paymentOptions)

  const handleChangePayment = value => {
    setPaymentType(value)
  }

  const showCodOption = paymentOptions.cod

  const isLtr = isDirectionLtr()

  return (
    <div className={classes["container"]}>
      <div className={classes["title"]}>
        {t("روش_های_پرداخت")}
      </div>

      <div className={classes["radio-container"]}>
        <div
          onClick={() => handleChangePayment("pcPos")}
          className={clsx(
            classes["radio"],
            paymentType === "pcPos" && classes["active"]
          )}
        >
          <span
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            <FaCoins
              size={18}
              className={clsx(
                classes["icon"],
                isLtr && classes["icon-ltr"]
              )}
            />

            {t("پرداخت_با_کارتخوان")}
          </span>

          <RadioButton
            className={classes["checkbox"]}
            checked={paymentType === "pcPos"}
          />
        </div>

        {
          showCodOption &&
          <div
            onClick={() => handleChangePayment("cod")}
            className={clsx(
              classes["radio"],
              paymentType === "cod" && classes["active"]
            )}
          >
            <span
              className={clsx(
                classes["text"],
                isLtr && classes["text-ltr"]
              )}
            >
              <FaMoneyBillWave
                size={20}
                className={clsx(
                  classes["icon"],
                  isLtr && classes["icon-ltr"]
                )}
              />

              {t("پرداخت_به_صندوق_دار")}
            </span>

            <RadioButton
              className={classes["checkbox"]}
              checked={paymentType === "cod"}
            />
          </div>
        }
      </div>
    </div>
  )
}

export default KcPaymentMethods